// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"e29b518d","408":"740cbcec"}[chunkId] + ".chunk.js";
};